import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
import { brandColors } from '../../theme';
import type { FeatureUpdate } from '../../types/ideaBoard';

interface FeatureUpdateEntryProps {
  update: FeatureUpdate;
  showDivider?: boolean;
}

const FeatureUpdateEntry: React.FC<FeatureUpdateEntryProps> = ({
  update,
  showDivider = true,
}) => {
  const formattedDate = new Date(update.createdAt).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <>
      <Box sx={{ display: 'flex', gap: 2, py: 2 }}>
        <Box
          sx={{
            flexShrink: 0,
            width: 36,
            height: 36,
            borderRadius: '50%',
            backgroundColor: `${brandColors.gold}20`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: brandColors.gold,
            mt: 0.25,
          }}
        >
          <NewReleasesOutlinedIcon fontSize="small" />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="caption"
            sx={{ color: brandColors.mediumGray, fontWeight: 500, display: 'block', mb: 0.5 }}
          >
            {formattedDate}
          </Typography>
          <Typography variant="body1" sx={{ color: brandColors.darkGray, lineHeight: 1.6 }}>
            {update.summary}
          </Typography>
        </Box>
      </Box>
      {showDivider && <Divider />}
    </>
  );
};

export default FeatureUpdateEntry;
